<div class="digi-report-popup-container">
  <div style="width: 100%;background-color: aliceblue;padding-bottom: 3px;" class="row">
    <div class="col-md-4" style="padding: 4px;">
      <mat-label class="device-label">Select Device</mat-label>
      <mat-select class="device-select" [(ngModel)]="selectedDevice" (selectionChange)="onDeviceSelect($event.value)">
        <mat-option  *ngFor="let dev of generatorIds" [value]="dev">
          {{ dev.digiid }} ({{ dev.sitename }})
        </mat-option>
      </mat-select>
    </div>
    <div class="col-md-4">
      <mat-label>Duration </mat-label>  
      <mat-select    [(value)]="timeFilter">
          <mat-option  *ngFor="let time of timeOptions" [value]="time"  (click)='filters(time)'>
              {{time}}
            </mat-option>
        </mat-select>
    </div>
    <div class="col-md-2">
      <p style="margin-left: 2%;"><b>Download In:</b></p>
                <div>
                  <button style="margin-left: 2%;"  mat-button (click)="exporter.exportTable('xlsx',{fileName:'Report'})"><img src="../../assets/images/icons8-microsoft-excel-30.png">
                  </button>
                </div>
    </div>
</div>
    <mat-tab-group mat-align-tabs="start" mat-stretch-tabs="false" [dynamicHeight]="true">
      <!-- Graph Tab -->
      <mat-tab label="Report">
        <div class="report-tab">
      
 
          <!-- Detailed Table -->
            <mat-card class="report-table-card">
              <div class="mat-elevation-z8">
                <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" matSort class="mat-table full-width">
            
                  <!-- Dynamic Column Definitions -->
                  <ng-container *ngFor="let col of reportColumns" [matColumnDef]="col">
                    <th mat-header-cell *matHeaderCellDef> {{ col | titlecase }} </th>
                    <td mat-cell *matCellDef="let row"> {{ row[col] }} </td>
                  </ng-container>
            
                  <!-- Header & Row Declarations -->
                  <tr mat-header-row *matHeaderRowDef="reportColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: reportColumns;"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
              </div>
            </mat-card>
            
  
         
        </div>
      </mat-tab>
  
      <!-- Report Tab -->
      <mat-tab label="Graph">

        <div class="graph-parameters-tab">
          <div class="graph-parameters-tab">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Select Parameter</mat-label>
              <mat-select [(value)]="selectedKey" (selectionChange)="loadChart($event.value)">
                <mat-option *ngFor="let key of keys" [value]="key">
                  {{ key }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          
            <div class="chart-container">
              <plotly-plot
                [data]="chartData"
                [layout]="chartLayout"
                [useResizeHandler]="true"
                [ngStyle]="{'width': '100%', 'height': '100%'}">
              </plotly-plot>
            </div>
            
          </div>
          
                 
        </div>

        
      </mat-tab>
    </mat-tab-group>
  </div>